import { Component } from "react";
import { Button } from "./Button";

export default class ErrorBoundaryComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      hasError: false,
      message: "",
      sendingBugsnagMessage: false
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
      hasError: true
    });
  }

  handleFormChange = (field, e) => {
    let nextState = {};
    nextState[field] = e.target.value;
    this.setState(nextState);
  };

  backToReplicated = () => {
    window.location.replace("/");
  };

  render() {
    const { info } = this.props;

    if (this.state.hasError || info) {
      return (
        <div className="flex-1 min-h-0 flex flex-col overflow-auto">
          <div className="flex-1 min-h-0 flex flex-col justify-center items-center">
            <div className="flex flex-col w-1/2">
              <span className="icon u-errorWarningIcon mb-10 text-center self-center"></span>
              <p className="text-center items-center text-[26px] font-semibold text-neutral-700">
                Oops, something went wrong.
              </p>
              <p className=" text-center mt-5 font-medium text-gray-410 text-sm leading-[1.4]">
                {" "}
                We’ve notified our team of the error that occurred and will be working
                to resolve the issue. We apologize for any inconvenience this may have
                caused.{" "}
              </p>
              <div className="flex items-center self-center mt-5">
                <Button
                  kind="secondary-gray"
                  className="mr-3"
                  onClick={() => this.backToReplicated()}
                >
                  {" "}
                  Back to Replicated{" "}
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div className="flex flex-col flex-1 min-h-0">{this.props.children}</div>;
    }
  }
}
